import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, getUserRole } from '../utils/auth';
import toast from 'react-hot-toast';

const ProtectedRoute = ({ children, role, allowedRoles }) => {
  const location = useLocation();
  const userRole = getUserRole();
  const isAuth = isAuthenticated();

  const roles = allowedRoles || (role ? [role] : []);

  // Show toast notification for unauthorized access
  useEffect(() => {
    if (isAuth && roles.length > 0 && userRole && !roles.includes(userRole)) {
      const rolesStr = roles.join(' or ');
      toast.error(`Access denied. This area is for ${rolesStr}s only.`);
    }
  }, [isAuth, roles, userRole]);

  // Check if user is authenticated
  if (!isAuth) {
    // Redirect to appropriate login page based on required role
    const primaryRole = roles[0] || 'user';
    if (primaryRole === 'admin') return <Navigate to="/admin/login" replace state={{ from: location }} />;
    if (primaryRole === 'owner') return <Navigate to="/owner/login" replace state={{ from: location }} />;
    return <Navigate to="/user/login" replace state={{ from: location }} />;
  }

  // Check if user has the required role
  if (roles.length > 0 && !roles.includes(userRole)) {
    // Redirect user to their appropriate dashboard based on their actual role
    if (userRole === 'admin') {
      return <Navigate to="/admin" replace />;
    }
    if (userRole === 'owner') {
      return <Navigate to="/owner" replace />;
    }
    if (userRole === 'user') {
      return <Navigate to="/" replace />;
    }

    // Fallback: if role is unknown, redirect to home
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
